import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { FaHome, FaFileUpload, FaShoppingCart, FaTree, FaFileInvoice, FaUser, FaWarehouse, FaFileAlt, FaUserTie, FaHandHoldingUsd, FaBoxOpen, FaIndustry, FaRulerCombined, FaShip, FaUserFriends, FaFileSignature, FaBoxes, FaStore, FaCreditCard, FaClipboardList, FaTruck, FaBuilding, FaReceipt, FaMoneyCheckAlt } from 'react-icons/fa';
import { FaSailboat } from 'react-icons/fa6';
import { LuCircleDollarSign } from 'react-icons/lu';
import ptcImage from '../../imagenes/ptc.jpg';

const generateID = (label) => {
    return `collapse${label.replace(/\s+/g, '').replace(/[^\w\s]/gi, '')}`;
}

export const isPathActive = (pathname, href) => (
    href && href !== '#' && (pathname === href || pathname.startsWith(`${href}/`))
);

export const itemsContainPath = (items, pathname) => items.some((item) => (
    item.subItems
        ? itemsContainPath(item.subItems, pathname)
        : isPathActive(pathname, item.href)
));

const MenuItem = ({ label, href, onClick, icon, nested = false, pathname }) => {
    const navigate = useNavigate();
    const itemRef = useRef(null);
    const active = isPathActive(pathname, href);

    useEffect(() => {
        if (active && itemRef.current?.scrollIntoView) {
            itemRef.current.scrollIntoView({ block: 'nearest' });
        }
    }, [active]);

    const handleClick = () => {
        if (onClick) {
            onClick();
        } else if (href && href !== '#') {
            navigate(href);
        }
    }

    return (
        <button
            ref={itemRef}
            type="button"
            className={`list-group-item list-group-item-action d-flex align-items-center${nested ? ' menu-subitem' : ''}${active ? ' menu-item-active' : ''}`}
            id="Menu-Item"
            onClick={handleClick}
            aria-current={active ? 'page' : undefined}
        >
            <span className="me-2">{icon}</span>
            <span>{label}</span>
        </button>
    )
}

const SubMenu = ({ label, items, icon, expanded, setExpanded, pathname, nested = false }) => {
    const collapseID = generateID(label);
    const branchActive = itemsContainPath(items, pathname);
    const isOpen = Object.prototype.hasOwnProperty.call(expanded, collapseID)
        ? expanded[collapseID]
        : branchActive;

    const toggleSubMenu = () => {
        setExpanded(prevState => ({ ...prevState, [collapseID]: !isOpen }));
    };

    return (
        <>
            <button
                type="button"
                className={`list-group-item list-group-item-action d-flex align-items-center menu-parent${isOpen ? ' menu-parent-open' : ''}${branchActive ? ' menu-branch-active' : ''}${nested ? ' menu-subitem' : ''}`}
                onClick={toggleSubMenu}
                aria-expanded={isOpen}
            >
                <span className="me-2">{icon}</span>
                <span className="flex-grow-1 text-start">{label}</span>
                <span className={`menu-caret${isOpen ? ' open' : ''}`} aria-hidden="true">▸</span>
            </button>
            {/* Apertura y cierre animados (ver .menu-submenu en App.css) */}
            <div className={`menu-submenu${isOpen ? ' open' : ''}`} id={collapseID}>
                <div className="menu-submenu-inner">
                    {items.map((item, index) => (
                        item.subItems ? (
                            <SubMenu
                                key={index}
                                label={item.label}
                                items={item.subItems}
                                icon={item.icon}
                                expanded={expanded}
                                setExpanded={setExpanded}
                                pathname={pathname}
                                nested
                            />
                        ) : (
                            <MenuItem key={index} label={item.label} href={item.href} icon={item.icon} pathname={pathname} nested />
                        )
                    ))}
                </div>
            </div>
        </>
    );
};

const Menu = ({ onHoverChange }) => {
    const [hover, setHover] = useState(true);
    const [expanded, setExpanded] = useState({});
    const { pathname } = useLocation();

    useEffect(() => {
        setExpanded({});
    }, [pathname]);

    const handleMouseEnter = () => {
        setHover(true);
        onHoverChange(true);
    };

    return (
        <div className="menu-container"
            onMouseEnter={handleMouseEnter}
            onMouseLeave={handleMouseEnter}
            style={{ width: hover ? 'var(--sidebar-width)' : '70px', transition: 'width 0.3s', display: 'flex', flexDirection: 'column', height: '100vh' }}>
            <div style={{ padding: 10, backgroundColor: '#fff' }}>
                <img
                    src={ptcImage}
                    alt="PTC"
                    style={{
                        display: 'block',
                        marginLeft: 'auto',
                        marginRight: 'auto',
                        width: '100%', // ocupa todo el ancho del contenedor
                        maxWidth: '140px', // opcional: define un tamaño máximo para la imagen
                        height: 'auto' // mantiene la proporción de la imagen
                    }}
                />
            </div>
            <div className="list-group flex-grow-1" style={{ width: '100%', maxHeight: '80vh', overflowY: 'auto' }}>
                <MenuItem label="Inicio" href="/home" icon={<FaHome />} pathname={pathname} />
                <SubMenu label="Logística" items={[
                    { label: 'Inventario', href: '/inventario', icon: <FaBoxes /> },
                    { label: 'Packing List', href: '/packinglist', icon: <FaClipboardList /> },
                    { label: 'Solicitudes Internas', href: '/solicitudesinterna', icon: <FaClipboardList /> },
                    { label: 'Gestión de Booking', href: '/solicitudes', icon: <FaShip /> },
                    { label: 'Control de embarques', href: '/control-embarques', icon: <FaShip /> },
                    { label: 'Tasas y Fletes', href: '/precios-fletes-tasas', icon: <FaMoneyCheckAlt /> },
                ]} icon={<FaTruck />} expanded={expanded} setExpanded={setExpanded} pathname={pathname} />
                <SubMenu label="Finanzas" items={[
                    { label: 'Proveedores', href: '/finanzas/proveedores', icon: <FaMoneyCheckAlt /> },
                ]} icon={<LuCircleDollarSign />} expanded={expanded} setExpanded={setExpanded} pathname={pathname} />
                <SubMenu label="Generar" items={[
                    { label: 'Ordenes Compra', href: '/ordenescompras', icon: <FaShoppingCart /> },
                    { label: 'Proformas Invoice', href: '/proforma', icon: <FaReceipt /> },
                    { label: 'Invoice', href: '/invoice', icon: <FaFileInvoice /> },
                ]} icon={<FaFileInvoice />} expanded={expanded} setExpanded={setExpanded} pathname={pathname} />
                <SubMenu label="Lector" items={[
                    { label: 'Lector Archivos', href: '/file', icon: <FaFileUpload /> },
                ]} icon={<FaFileUpload />} expanded={expanded} setExpanded={setExpanded} pathname={pathname} />
                <SubMenu label="Registros" items={[
                    { label: 'Almacenes', href: '/almacen', icon: <FaWarehouse /> },
                    { label: 'Carta de crédito', href: '/cartascreditos', icon: <FaCreditCard /> },
                    { label: 'Carriers', href: '/carrier', icon: <FaSailboat /> },
                    { label: 'Clientes', href: '/cliente', icon: <FaUserTie /> },
                    { label: 'FFW', href: '/ffws', icon: <FaTruck /> },
                    { label: 'IncoTerms', href: '/incoterm', icon: <FaFileSignature /> },
                    { label: 'Línea de Crédito', href: '/lineascreditos', icon: <FaHandHoldingUsd /> },
                    { label: 'Notas Fiscales', href: '/notasfiscale', icon: <FaReceipt /> },
                    {
                        label: 'Productos', href: '#', subItems: [
                            { label: 'Calidades', href: '/calidad', icon: <FaBoxes /> },
                            { label: 'Categorias', href: '/categoria', icon: <FaClipboardList /> },
                            { label: 'Especies', href: '/especie', icon: <FaTree /> },
                            { label: 'Medidas', href: '/medida', icon: <FaRulerCombined /> },
                            { label: 'Productos', href: '/producto', icon: <FaBoxOpen /> }
                        ], icon: <FaIndustry />
                    },
                    { label: 'Payment Terms', href: '/paymentterm', icon: <FaFileSignature /> },
                    { label: 'Proveedores', href: '/proveedores1', icon: <FaBuilding /> },
                    { label: 'Puertos', href: '/puerto', icon: <FaShip /> },
                    { label: 'ShippingDocs', href: '/shippingdoc', icon: <FaFileAlt /> },
                    { label: 'Sub-Clientes', href: '/subcliente', icon: <FaUserFriends /> },
                    { label: 'Tipos de Documentos', href: '/documentos1', icon: <FaFileAlt /> },
                    { label: 'Usuarios', href: '/usuariosVista', icon: <FaUser /> }
                ]} icon={<FaStore />} expanded={expanded} setExpanded={setExpanded} pathname={pathname} />
            </div>
        </div>
    );
};

export default Menu;
